export enum Statuses {
  TOTAL_TXS = 'totalTxs',
  NATIVE_CURR = 'nativeCurr',
  TOKEN_BALANCE = 'tokenBalance',
  TOTAL_ADDRESSES = 'totalAddresses',
  APPROXIMATE_COST = 'approximateCost',
  TOTAL_TOKENS_TO_SEND = 'totalTokensToSend',
}

export type Stat = { label: string; data: string | number }

export type StatsRecord = Record<Statuses, Stat>
